import { render, staticRenderFns } from "./SecondaryTableCost.vue?vue&type=template&id=1bee2ece&"
import script from "./SecondaryTableCost.vue?vue&type=script&lang=js&"
export * from "./SecondaryTableCost.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports